import { action } from 'typesafe-actions';
import { UserActionTypes } from './types';

export const resetPasswordSuccess = (username: string) => action(UserActionTypes.RESET_USER_SUCCESS, { username });
export const resetPasswordFailure = (error: string) => action(UserActionTypes.RESET_USER_FAILURE, error);

export const reinviteUser = (uniId: string, username: string, pathway?: string) =>
  action(UserActionTypes.REINVITE_USER, {
    uniId,
    username,
    pathway,
  });

export const reinviteUserSuccess = (username: string) => action(UserActionTypes.REINVITE_USER_SUCCESS, { username });
export const reinviteUserFailure = (error: string) => action(UserActionTypes.REINVITE_USER_FAILURE, error);
